import '@/locales/i18n';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useEffect, useState } from 'react';
import { Toaster } from 'react-hot-toast';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import { ProvideAuth } from '@/features/auth/hooks/use-auth';
import { ProvideSettings } from '@/features/user-settings';
import { router } from '@/router';
import { Theme } from '@/utils/types';

import { DemoProvider } from './features/demo/tour-provider';

const queryClient = new QueryClient();

function App() {
  // here we set the global theme of the application
  const [theme, setTheme] = useState(Theme.Wine);

  // dynamically set favicon
  useEffect(() => {
    const favicon = document.getElementById('favicon') as HTMLAnchorElement | null;
    if (favicon) favicon.href = `/${theme}-favicon.ico`;
  }, [theme]);

  return (
    <ThemeProvider theme={{ current: theme, setTheme }}>
      <Toaster />
      <ProvideAuth>
        <QueryClientProvider client={queryClient}>
          <ProvideSettings>
            <DemoProvider>
              <RouterProvider router={router} />
            </DemoProvider>
          </ProvideSettings>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </ProvideAuth>
    </ThemeProvider>
  );
}

export default App;
